const PageMainContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <main className="z-20 animate-fade-in space-y-4 bg-gradient-to-b from-transparent to-black to-[50px] px-6 pb-6">
      {children}
    </main>
  )
}

export default PageMainContainer
